module.exports = __webpack_public_path__ + "static/img/_MG_4577-slim.96ad646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_MG_4577-slim.jpg
// module id = Xgot
// module chunks = 0